import { HelpBoxOutlineIcon } from './HelpBoxOutlineIcon';

/**
 * author: Michael Irigoyen
 * id C7559D85-14BB-4C5C-B37C-D37E85FEE258
 * name help-box-outline
 * version: 7.1.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/help-box-outline.svg
 * tags
 */
export const QuestionBoxOutlineIcon = HelpBoxOutlineIcon;
export default QuestionBoxOutlineIcon